import ContactForm from '../components/ContactForm';
import Modals from '../components/modals';

class ContactPage {
	constructor() {
		if (document.getElementById('contactForm')) {
			new ContactForm();
		}
		
		new Modals();
	}

}

new ContactPage();